import React from 'react';
import firebase from 'firebase';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
var firebaseConfig = {
  apiKey: "AIzaSyCNGgVlW4eHAD3VCMiHK1ayNV8sOVM2q-c",
  authDomain: "ms-teams-clone-1.firebaseapp.com",
  projectId: "ms-teams-clone-1",
  storageBucket: "ms-teams-clone-1.appspot.com",
  messagingSenderId: "1021030799668",
  appId: "1:1021030799668:web:44341c0e0892b171136d61",
  measurementId: "G-8L9DLXL1HZ"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

  export default firebase;



// WEBPACK FOOTER //
// ./src/Services/firebase.js